module.exports = __webpack_public_path__ + "img/i30_hatchback.b8ebd21a.png";